import React, { Component } from 'react';

import Breadcrumb from "../common/breadcrumb";
import { Link } from 'react-router-dom';
import { CustomerRegister, GetToken, TokenValidation } from '../../services/api.js'
import Swal from 'sweetalert2'
import { Helmet } from 'react-helmet';
import Logo from "../../assets/logo/ezlogo3.png";
import TopBarProgress from "react-topbar-progress-indicator";

class Register extends Component {

    constructor(props) {
        super(props);
    }
    state = {
        callback: null,
        FirstName: '',
        LastName: '',
        Password: '',
        Mobile: '',
        NationalId: '',
        confirmPassword: '',
        Code: '',
        getCode: false,
        sendMobile: true,
        resend: true,
        loading: false,
        timer: 60,
        initialTimer: 60,
    }
    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        let callback = searchParams.get('callback');
        this.setState(state => ({ ...state, callback }));
    };
    startTimer = () => {
        this.setState((state) => ({ ...state, timer: state.initialTimer }));
        let interval = setInterval(() => {
            if (this.state.timer === 0) {
                clearInterval(interval);
                this.setState((state) => ({ ...state, timer: null }));
                return;
            }
            let timer = this.state.timer;
            this.setState((state) => ({ ...state, timer: timer - 1 }));
        }, 1000);
    };
    submit = async () => {
        if (this.state.Password === this.state.confirmPassword) {
            let payload = {
                
                Password: this.state.Password,
               
            }
            await CustomerRegister(payload, this.state.callback)
        } else {
            Swal.fire({
                title: '!خطا',
                text: 'رمز عبور یکسان نمی باشد',
                icon: 'error',
                confirmButtonText: 'تایید'
            })
        }


    }
    sendCode = async () => {
        this.setState(state => ({ ...state, loading: true }));
        let data = await GetToken(this.state.Mobile)
        if (data.status === 200) {
            this.setState((old) => ({ ...old, getCode: true, sendMobile: false, loading: false }))
            this.startTimer()
        }

    }
    validationCode = async () => {
        this.setState(state => ({ ...state, loading: true }));
        let pay = {
            mobileNo: this.state.Mobile,
            token: this.state.Code
        }
        let data = await TokenValidation(pay)
        if (data === 200) {
            this.setState((old) => ({ ...old, getCode: false, sendMobile: false, loading: false  }))
        }

    }

    render() {


        return (
            <div>
                <Helmet>
                    <title>ایزی کارت 724 | ثبت نام</title>
                    <meta name="description" content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses." />
                </Helmet>
                {/* <Breadcrumb title={'ثبت نام'}/> */}

          
                {/*Regsiter section*/}
                <section className="register-page section-b-space">
                {this.state.loading && <TopBarProgress />

}
                    <div className="container">
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div className="col-lg-6" >
                                {this.state.sendMobile &&
                                    < div className="theme-card mx-auto" >
                                        <div className='text-center' style={{ marginTop: '-3rem' }}>
                                            <img src={Logo} alt="" className="img-fluid" />
                                        </div>
                                        <div className='mt-5'>
                                            <h6>سلام!</h6>
                                            <h6>لطفا شماره موبایل خود را جهت دریافت کد وارد نمایید.</h6>
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="review">موبایل</label>
                                            <input type="text" className="form-control" id="mobile"
                                                placeholder="موبایل" value={this.state.Mobile} onChange={(e) => this.setState({ Mobile: e.target.value })} required="" />
                                        </div>
                                        <div className="text-center mt-5">
                                            <button className="btn btn-solid " onClick={this.sendCode}>تایید</button>

                                        </div>

                                   
                                    </div>
                                }
                                {this.state.getCode &&
                                    <div className="theme-card mx-auto">
                                        <div className='text-center' style={{ marginTop: '-3rem' }}>
                                            <img src={Logo} alt="" className="img-fluid" />
                                        </div>
                                        <div className='mt-5'>
                                            <h6>کد ارسال شده به شماره {this.state.Mobile} را وارد نمایید.</h6>
                                        </div>
                                        <div className="my-2">
                                            <input type="text" className="form-control" id="mobile"
                                                placeholder="کد را وارد نمایید" value={this.state.Code} onChange={(e) => this.setState({ Code: e.target.value })} required="" />
                                        </div>
                                        <div className="text-center mt-5">
                                            <button className="btn btn-solid " onClick={this.validationCode}>تایید</button>

                                        </div>
                                        <div className="text-center mt-3" style={{ cursor: 'pointer' }} >
                                            {!!this.state.timer ?
                                                <h6 className="text-center"><i class="fa fa-refresh ml-2" style={{ color: 'red' }} aria-hidden="true" ></i>{this.state.timer} ثانیه</h6>
                                                :
                                                <h6 disabled={this.resend} className="text-center" onClick={this.sendCode}><i class="fa fa-refresh ml-2" style={{ color: 'red' }} aria-hidden="true" ></i>ارسال مجدد</h6>
                                            }
                                            {/* <Link to="/pages/login">
                                            <div className="btn btn-primary p-3 mt-3">قبلا ثبت نام کرده اید؟ وارد شوید</div>
                                        </Link> */}
                                        </div>
                                    </div>
                                }
                                {(!this.state.sendMobile && !this.state.getCode) &&
                                    < div className="theme-card">
                                        <form className="theme-form">
                                        <div className='text-center' style={{ marginTop: '-3rem' }}>
                                            <img src={Logo} alt="" className="img-fluid" />
                                        </div>
                                            <h3 className='text-center'>رمز عبور</h3>
                                        

                                            <div className="form-row">
                                                <div className="col-md-12">
                                                    <label htmlFor="review">رمز عبور جدید</label>
                                                    <input type="password" className="form-control" id="review"
                                                        placeholder="رمز عبور خود را وارد کنید" value={this.state.Password} onChange={(e) => this.setState({ Password: e.target.value })} required="" />
                                                </div>

                                                <div className="col-md-12">
                                                    <label htmlFor="review">تایید رمز عبور</label>
                                                    <input type="password" className="form-control" id="review"
                                                        placeholder="تاییدیه رمز عبور" value={this.state.confirmPassword} onChange={(e) => this.setState({ confirmPassword: e.target.value })} required="" />
                                                </div>

                                            </div>


                                        </form>
                                        <div className="text-center">
                                            <button className="btn btn-solid " onClick={this.submit}>تایید</button>

                                        </div>
                                     
                                    </div>
                                }





                            </div>
                        </div>
                    </div>
                </section >

            </div >
        )
    }
}

export default Register